import Icon from '../components/Icon.vue'

Icon.register({
  'laugh-beam': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM272 207.4C275.3 165.3 304.2 136 328 136S380.7 165.3 384 207.4C384.7 216 373.2 219.3 369.1 211.9L359.6 194.9C351.9 181.2 340.4 173.3 328.1 173.3S304.3 181.2 296.6 194.9L287.1 211.9C282.9 219.3 271.3 216 272 207.4zM112 207.4C115.3 165.3 144.2 136 168 136S220.7 165.3 224 207.4C224.7 216 213.2 219.3 209.1 211.9L199.6 194.9C191.9 181.2 180.4 173.3 168.1 173.3S144.3 181.2 136.6 194.9L127.1 211.9C122.8 219.3 111.3 215.9 112 207.4zM398.9 306C390 377 329.4 432 256 432H240C166.6 432 106 377 97.1 306 95.9 296.5 103.4 288 113 288H383C392.6 288 400.1 296.4 398.9 306z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/laugh-beam.js
// module id = rwP5
// module chunks = 144